import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Header = _resolveComponent("Header");
  const _component_t_header = _resolveComponent("t-header");
  const _component_router_view = _resolveComponent("router-view");
  const _component_t_content = _resolveComponent("t-content");
  const _component_t_layout = _resolveComponent("t-layout");
  const _component_perfect_scrollbar = _resolveComponent("perfect-scrollbar");
  return _openBlock(), _createBlock(_component_perfect_scrollbar, {
    ref: "scroll"
  }, {
    default: _withCtx(() => [_createVNode(_component_t_layout, {
      style: {
        "height": "100%",
        "width": "100%",
        "min-width": "1200px",
        "min-height": "800px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_t_header, {
        style: {
          "height": "72px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_Header, {
          infos: "Welcome"
        })]),
        _: 1
      }), _createVNode(_component_t_content, null, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 512);
}